export function objectToFormData(obj, form = new FormData(), namespace = '') {
    for (let property in obj) {
        if (!Object.hasOwn(obj, property) || obj[property] == null) continue;

        let formKey = namespace ? `${namespace}[${property}]` : property;
        let value = obj[property];

        if (value instanceof File || value instanceof Blob) {
            form.append(formKey, value);
        } else if (typeof value === 'object' && !(value instanceof Date)) {
            objectToFormData(value, form, formKey);
        } else {
            form.append(formKey, value);
        }
    }

    return form;
}
